import React from "react"
import { useField } from "formik"

export default function TextInput({ label, className, ...props }) {
  const [field, meta] = useField(props)

  return (
    <div className={className}>
      <label htmlFor={props.id || props.name} className="subtitle mb-2">
        {label}
      </label>
      <input className="px-3 py-2 bg-gray-200/50" {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className="text-red-600 mt-2">{meta.error}</div>
      ) : null}
    </div>
  )
}
